module.exports = require("rdflib");